import { formatARS } from '../../../utils/currency';

const ProductCard = ({
  item,
  onPrimaryAction,
  onCardClick,
  primaryActionLabel,
  primaryActionIcon,
  isCardClickable,
}) => {
  const {
    name,
    description,
    imageUrl,
    placeholderIcon,
    meta,
    finalPrice,
    originalPrice,
    discountPercent,
  } = item;

  const cardProps = { className: 'card' };
  if (isCardClickable) {
    cardProps.className = 'card card--clickable';
    cardProps.onClick = () => onCardClick?.(item);
    cardProps.onKeyUp = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onCardClick?.(item);
      }
    };
    cardProps.role = 'button';
    cardProps.tabIndex = 0;
  }

  return (
    <div {...cardProps}>
      {discountPercent > 0 && <div className="card__badge">¡OFERTA!</div>}
      <div className="card__image-container">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            className="card__image"
            loading="lazy"
            onError={(event) => {
              event.currentTarget.style.display = 'none';
              if (event.currentTarget.nextElementSibling) {
                event.currentTarget.nextElementSibling.style.display = 'flex';
              }
            }}
          />
        ) : null}
        <div
          className={`card__placeholder ${placeholderIcon ? `card__placeholder--${item.type}` : ''}`}
          style={{ display: imageUrl ? 'none' : 'flex' }}
        >
          <i className={placeholderIcon} aria-hidden="true" />
        </div>
      </div>

      <div className="card__content">
        <div className="card__header">
          <h3 className="card__title">{name}</h3>
          <p className="card__description">{description}</p>
        </div>

        <div className="card__footer">
          {meta ? (
            <div className="card__meta">
              <i className={`${meta.icon} card__meta-icon`} aria-hidden="true" />
              <span>{meta.text}</span>
            </div>
          ) : null}
          <div className="card__price-section">
            <div className="card__price-container">
              {discountPercent > 0 && originalPrice > finalPrice ? (
                <span className="card__price-old">{formatARS(originalPrice)}</span>
              ) : null}
              <span className="card__price">{formatARS(finalPrice)}</span>
              {discountPercent > 0 ? <span className="card__discount">-{discountPercent}%</span> : null}
            </div>
          </div>

          <div className="card__action">
            <button
              type="button"
              className="btn btn--primary btn--sm card__action-btn"
              onClick={(event) => {
                event.stopPropagation();
                onPrimaryAction?.(item);
              }}
            >
              <i className={primaryActionIcon} aria-hidden="true" />
              <span>{primaryActionLabel}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductCard.defaultProps = {
  onPrimaryAction: undefined,
  onCardClick: undefined,
  primaryActionLabel: 'Ver Detalles',
  primaryActionIcon: 'fas fa-arrow-right',
  isCardClickable: false,
};

export default ProductCard;

